module.exports = __webpack_public_path__ + "2bad24f3a0c9b8c2433e34d7a37bccde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/state_farm_2023_chart.png
// module id = 1734
// module chunks = 0